import React from "react";
import cns from "classnames";
import { Checkbox, FormControlLabel, Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { Subheading } from "@common/typography/FormSubheading";
import locale from "@bonliva-crm/locale";

type Props = React.ComponentProps<typeof Grid> & {
  className?: string;
  fitted?: boolean;
  flat?: boolean;
  fullWidth?: boolean;
  PaperProps?: Partial<React.ComponentProps<typeof Paper>>;
  title?: string;
  withBorder?: boolean;
  hasValidated?: boolean;
  colorSectionForNotApproved?: boolean;
  validate?: (e, checked) => void;
};

/**
 * Display left label and the field together inside grid items
 */
export function ConsultantFormSection(props: Props) {
  const {
    children,
    className,
    fitted,
    flat,
    fullWidth,
    PaperProps: PaperPropsProp,
    title,
    withBorder,
    hasValidated,
    validate,
    colorSectionForNotApproved,
    ...rest
  } = props;

  const classes = useStyles({});

  const rootClassName = cns(classes.root, className, {
    [classes.responsive]: !fullWidth
  });

  const content = (
    <div
      className={cns({
        [classes.notApproved]: !hasValidated && validate && colorSectionForNotApproved
      })}
    >
      {title && (
        <Subheading className={classes.title}>
          {title}

          {!hasValidated && validate && (
            <FormControlLabel
              className={classes.approveFormLabel}
              control={
                <Checkbox
                  checked={false}
                  className={classes.approve}
                  onChange={validate}
                  value="validate"
                  color="secondary"
                />
              }
              label={
                <Typography className={classes.approve}>{locale.Approve}</Typography>
              }
              labelPlacement="start"
            />
          )}
        </Subheading>
      )}
      {children}
    </div>
  );

  return (
    <Grid component={"section" as any} item className={rootClassName} {...rest}>
      {fitted && content}
      {!fitted && (
        <Paper
          className={cns(classes.section, {
            [classes.withBorder]: withBorder
          })}
          elevation={flat ? 0 : 1}
          {...PaperPropsProp}
        >
          {content}
        </Paper>
      )}
    </Grid>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    width: "100%"
  },

  responsive: {
    [theme.breakpoints.up("md")]: {
      width: "50%"
    },

    [theme.breakpoints.up("xl")]: {
      width: "50%"
    }
  },

  section: {
    padding: theme.spacing(2)
  },

  withBorder: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.grey[200]
  },

  notApproved: {
    ...theme.palette.error
  },
  approve: {
    color: theme.palette.error.main
  },
  approveFormLabel: {
    float: "right",
    paddingRight: theme.spacing()
  },
  title: {
    marginBottom: theme.spacing()
  }
}));

export default ConsultantFormSection;
